import { motion } from 'framer-motion'
import { AlertCircle, RefreshCw, Database } from 'lucide-react'
import { Button } from './ui/button'

interface PresentationLibraryErrorProps {
  error: string
  onRetry: () => void
  onShowLocal: () => void
  hasLocalPresentations: boolean
}

export function PresentationLibraryError({
  error,
  onRetry,
  onShowLocal,
  hasLocalPresentations
}: PresentationLibraryErrorProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="rounded-lg border border-destructive/50 bg-destructive/5 p-6"
    >
      <div className="flex items-start gap-4">
        {/* Error Icon */}
        <div className="flex-shrink-0">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
            <AlertCircle className="h-6 w-6 text-destructive" />
          </div>
        </div>

        {/* Error Content */}
        <div className="flex-1 space-y-2">
          <h3 className="text-lg font-semibold text-foreground">
            Unable to Load Presentations
          </h3>
          <p className="text-sm text-muted-foreground">
            {error || 'An unexpected error occurred while fetching presentations from the server.'}
          </p>
          <p className="text-xs text-muted-foreground">
            Check the browser console for more details about this error.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-wrap items-center gap-3 mt-4">
            <Button
              onClick={onRetry}
              variant="default"
              size="sm"
              className="gap-2"
            >
              <RefreshCw className="h-4 w-4" />
              Retry
            </Button>

            {hasLocalPresentations && (
              <Button
                onClick={onShowLocal}
                variant="outline"
                size="sm"
                className="gap-2"
              >
                <Database className="h-4 w-4" />
                Show Local Presentations
              </Button>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  )
}
